import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=b5f9204a"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=b5f9204a&prod&lang=scss"
import style1 from "./CompanyCard.vue?vue&type=style&index=1&id=b5f9204a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports